import { InjectionToken, Provider } from '@angular/core';
import { CustomPageType, MenuItemNested } from '@core/const';
import { ActionReducerMap, combineReducers } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { CoreState, FEATURE_FLAGS, MENU_NESTED } from '../core-state';
import { reducer as fromPageIndexReducer } from './page-index.reducer';

export type CoreReducers = CoreState;

export function getReducers(): ActionReducerMap<CoreReducers> {
  return {
    featureFlags: StateUtils.loaderReducer(FEATURE_FLAGS),
    customCms: combineReducers({
      pageIndex: combineReducers({
        [CustomPageType.CampaignPage]: StateUtils.entityLoaderReducer<string>(
          CustomPageType.CampaignPage,
          fromPageIndexReducer(CustomPageType.CampaignPage),
        ),
        [CustomPageType.ArticlePage]: StateUtils.entityLoaderReducer<string>(
          CustomPageType.ArticlePage,
          fromPageIndexReducer(CustomPageType.ArticlePage),
        ),
        [CustomPageType.TagPage]: StateUtils.entityLoaderReducer<string>(
          CustomPageType.TagPage,
          fromPageIndexReducer(CustomPageType.TagPage),
        ),
      }),
    }),
    menusNested: StateUtils.entityLoaderReducer<MenuItemNested[]>(MENU_NESTED),
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CoreReducers>> = new InjectionToken<
  ActionReducerMap<CoreReducers>
>('CoreReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
